import React from 'react';
import image from '@/public/images/contact_us/map.webp';
import Image from 'next/image';
import style from './Map.module.scss';

export const Map = ({ children }) => {
  return (
    <div className="relative">
      <div className={style.overlay}></div>
      <Image
        style={{ height: '764px', objectFit: 'cover' }}
        src={image}
        alt="map"
      />
      <div className={style.childrenWrapper}>{children}</div>
    </div>
  );
};
